import Tags from './Tags/Tags';

export default Tags;
